import i18next from "i18next";

export function initializeConfiguratorLocale(
  search = window.location.search,
): void {
  const lang = new URLSearchParams(search).get("lang");
  i18next.init(() => {
    i18next.changeLanguage(
      lang === "en" || lang === "de" || lang === "tr" ? lang : "tr",
    );
  });
}
